<template>
    <div>
        <v-data-iterator
            :items="referralTransactions"
            item-key="id"
            :items-per-page="-1"
            hide-default-footer
        >
            <template #default="{ items }">
                <v-row>
                    <v-col
                        v-for="item in items"
                        :key="item.id"
                        cols="12"
                    >
                        <v-card
                            class="bordered-card py-4 px-2"
                            elevation="0"
                            outlined
                        >
                            <v-row class="align-center text-no-wrap">
                                <v-col
                                    cols="1"
                                    class="grey--text text--darken-1"
                                >
                                    Credited:
                                </v-col>
                                <v-col
                                    cols="2"
                                    class="text-truncate ellipsis"
                                >
                                    {{ item.currency_code }}
                                    {{ item.amount }}
                                </v-col>
                                <v-col
                                    cols="1"
                                    class="grey--text text--darken-1"
                                >
                                    Narration:
                                </v-col>
                                <v-col cols="3">
                                    Commission from Referral
                                </v-col>
                                <v-col
                                    cols="2"
                                    class="grey--text text--darken-1"
                                >
                                    Transaction ID:
                                </v-col>
                                <v-col cols="2">
                                    {{ item.order_id }}
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </template>
        </v-data-iterator>

        <v-pagination
            v-model="pagination.page"
            :length="pagination.pageCount"
            class="mt-4"
        />
    </div>
</template>

<script>
export default {
    data: () => ({
        referralTransactions: [],
    }),
    mounted() {
        this.getReferralTransactions();
    },
    methods: {
        async getReferralTransactions() {
            try {
                this.loading = true;

                const { searchText: search } = this;

                const params = {
                    ...this.pagination,
                    search,
                    type: 'credit',
                };

                const { data } = await Vue.backendApi()
                    .referralTransactions()
                    .getAll(params);

                const { models, pagination } = data;
                this.referralTransactions = models;
                this.pagination = pagination;
            } catch (error) {
                this.$swal({
                    type: 'error',
                    title: 'Error fetching referral transactions',
                    text: error,
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.bordered-card.v-card {
    background-color: #D2CFDD;
    border-color: #000000;
}
</style>
